const { BaseCollection } = require('./_base.collection')

/**
 * @typedef UserModel
 * @property {string} id
 * @property {string=} displayName
 * @property {string=} email
 * @property {string=} phoneNumber
 * @property {string=} photoURL
 * @property {string=} plan
 * @property {string=} paymentMethod
 * @property {string=} stripeCustomerId
 * @property {string=} stripeSubscriptionId
 * @property {string=} stripeSubscriptionStatus
 * @property {string=} bankTransferStatus
 * @property {boolean=} isNotificationEnabled
 */

/**
 * @extends {BaseCollection<UserModel>}
 */
class UserCollection extends BaseCollection {
  constructor() {
    super('USERS')
  }

  /**
   *
   * @param {string} stripeCustomerId
   * @returns {PromiseLike<UserModel | null>}
   */
  findByStripeCustomerId(stripeCustomerId) {
    return this.collection
      .where('stripeCustomerId', '==', stripeCustomerId)
      .limit(1)
      .get()
      .then((snap) => (snap.docs.length > 0 ? snap.docs[0].data() : null))
  }
}

const userCollection = new UserCollection()

const PaymentMethod = {
  CREDIT_CARD: 'credit_card',
  BANK_TRANSFER: 'bank_transfer',

  all: () => {
    return [PaymentMethod.CREDIT_CARD, PaymentMethod.BANK_TRANSFER]
  },

  getLabel(paymentMethod) {
    const labelMap = {
      [PaymentMethod.CREDIT_CARD]: 'クレジットカード',
      [PaymentMethod.BANK_TRANSFER]: '銀行振込'
    }

    return labelMap[paymentMethod]
  }
}

const Plan = {
  ONE_TIME_PURCHASE: 'one_time_purchase',
  SUBSCRIPTION_30: 'subscription_30',
  SUBSCRIPTION_40: 'subscription_40',
  SUBSCRIPTION_50: 'subscription_50',

  all: () => {
    return [Plan.ONE_TIME_PURCHASE, Plan.SUBSCRIPTION_30, Plan.SUBSCRIPTION_40, Plan.SUBSCRIPTION_50]
  },

  getDefaultPlan: () => Plan.SUBSCRIPTION_30,

  getName: (plan) => {
    const planNameMap = {
      [Plan.ONE_TIME_PURCHASE]: '単品購入',
      [Plan.SUBSCRIPTION_30]: '定期購入（30日ごと）',
      [Plan.SUBSCRIPTION_40]: '定期購入（40日ごと）',
      [Plan.SUBSCRIPTION_50]: '定期購入（50日ごと）'
    }

    return planNameMap[plan]
  },

  getDesc: (plan) => {
    const desc1 = '定価¥4,950(税込)\nプラス送料が360円がかかります。'
    const desc2 = '送料はずっと無料でお届け\n配送頻度の変更可能\nいつでも解約OKで縛りなし'
    const planDescMap = {
      [Plan.ONE_TIME_PURCHASE]: desc1,
      [Plan.SUBSCRIPTION_30]: desc2,
      [Plan.SUBSCRIPTION_40]: desc2,
      [Plan.SUBSCRIPTION_50]: desc2
    }

    return planDescMap[plan]
  },

  getSubtotal: (plan) => {
    const subtotalMap = {
      [Plan.ONE_TIME_PURCHASE]: 5310,
      [Plan.SUBSCRIPTION_30]: 3960,
      [Plan.SUBSCRIPTION_40]: 3960,
      [Plan.SUBSCRIPTION_50]: 3960
    }

    return subtotalMap[plan] || 0
  }
}

module.exports = {
  PaymentMethod,
  Plan,
  userCollection
}
